import React from 'react';
import { connect } from 'react-redux';
import { generatePath, Redirect } from 'react-router-dom';
import { ResourcesItem } from 'redux-and-the-rest';

import { UserModel } from '../../models/userModel';
import { getUser } from '../../redux/reducers/userReducer';
import { ApplicationState } from '../../redux/types';
import { Routes } from '../../routes';

interface Props {
  user: ResourcesItem<UserModel>;
}

const Schools = ({ user }: Props): React.ReactElement => {
  const schoolId = user.values.schools[0].id;

  return (
    <Redirect to={generatePath(Routes.Account.School.Edit, {
      id: schoolId,
    })}
    />
  );
};

const mapReduxStateToProps = (
  { users }: ApplicationState,
) => ({
  user: getUser(users),
});

export default connect(mapReduxStateToProps)(Schools);
